import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { IonIcon } from 'controls'
import { stepItem } from './styles'

class StepItem extends PureComponent {
  static propTypes = {
    completed: PropTypes.bool,
    number: PropTypes.number.isRequired,
    filled: PropTypes.bool,
  }

  static defaultProps = {
    completed: false,
    number: 1,
    filled: false,
  }

  render() {
    const { completed, filled } = this.props

    return (
      <div className={classnames("step-item-container", { filled, completed })}>
        <div className="icons">
          <div className="step-icon">
            <IonIcon icon='android-done' className="check-icon" />
          </div>
          <div className={classnames('step-icon', 'number', {completed})}>
            {!completed ? this.props.number : <IonIcon icon="md-checkmark"/>}
          </div>
        </div>
        {Boolean(this.props.children) && (
          <div className={classnames('step-description', { completed })}>
            {this.props.children}
          </div>
        )}
        <style jsx global>{stepItem}</style>
      </div>
    )
  }
}

export default StepItem
